import { BaseRestRepository } from './baseRestRepository';
import type { CreateLeaseTemplateCategoryDto, LeaseTemplateCategoryDto } from '~/swagger/portal/Api';

const LEASE_TEMPLATE_CATEGORY_URL = '/api/lease-templates/categories';

export class LeaseTemplateCategoryRepository extends BaseRestRepository {
  public async getLeaseTemplateCategories(): Promise<LeaseTemplateCategoryDto[]> {
    const response = await this.fetchWithAuth(LEASE_TEMPLATE_CATEGORY_URL);
    return this.getJsonResponse(response);
  }

  public async createLeaseTemplateCategory(payload: CreateLeaseTemplateCategoryDto): Promise<LeaseTemplateCategoryDto> {
    const response = await this.fetchWithAuth(LEASE_TEMPLATE_CATEGORY_URL, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async updateLeaseTemplateCategory(id: string, payload: CreateLeaseTemplateCategoryDto): Promise<LeaseTemplateCategoryDto> {
    const url = `${LEASE_TEMPLATE_CATEGORY_URL}/${id}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteLeaseTemplateCategory(id: string): Promise<void> {
    const url = `${LEASE_TEMPLATE_CATEGORY_URL}/${id}`;
    await this.fetchWithAuth(url, { method: 'DELETE' });
  }
}
